/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  ShortText,
  Icon,
} from 'components/common';
import successImage from 'assets/jobs/sucess-post-job.png';

import {
  modalStyles,
  contentStyles,
  imageContainerStyles,
  descriptionContainerStyles,
  buttonContainerStyles,
} from './ConfirmationModal.styles';

const ConfirmationModal = ({
  isLoadingRecommendation,
  isConfirmationModalOpen,
  setConfirmationModal,
  selectedRecommendation,
  handleClick,
}) => (
  <Modal
    isModalOpen={isConfirmationModalOpen}
    setModal={setConfirmationModal}
    styles={modalStyles}
  >
    <div css={contentStyles}>
      <Icon onClick={() => setConfirmationModal(false)} name="times" />
      <div css={imageContainerStyles}>
        <img src={successImage} alt="success-post-job" />
      </div>
      <div css={descriptionContainerStyles}>
        <ShortText>Job Invitation Confirmation</ShortText>
        <ShortText>
          Confirmation, Are you sure you want to invite selected member
          as &nbsp;
          {selectedRecommendation.jobName}
          &nbsp;to your selected active job?
        </ShortText>
      </div>
      <div css={buttonContainerStyles}>
        <Button
          type="button"
          onClick={() => setConfirmationModal(false)}
        >
          cancel
        </Button>
        <Button
          disabled={isLoadingRecommendation}
          type="button"
          onClick={handleClick}
        >
          yes, continue
        </Button>
      </div>
    </div>
  </Modal>
);
ConfirmationModal.propTypes = {
  isLoadingRecommendation: PropTypes.bool.isRequired,
  isConfirmationModalOpen: PropTypes.bool.isRequired,
  setConfirmationModal: PropTypes.func.isRequired,
  selectedRecommendation: PropTypes.shape({
    jobName: PropTypes.string,
  }).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default ConfirmationModal;
